"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../hooks");
var list_entry_1 = __importDefault(require("./list-entry"));
var header_1 = __importDefault(require("./header"));
function ChatListPanel(_a) {
    var chats = _a.chats, openChatId = _a.openChatId, filter = _a.filter, hasNextPageChats = _a.hasNextPageChats, isFetchingNextPageChats = _a.isFetchingNextPageChats, handleSwitchOpenChatId = _a.handleSwitchOpenChatId, setFilter = _a.setFilter, fetchNextPageChats = _a.fetchNextPageChats;
    var listCollapsed = (0, hooks_1.useChatListCollapse)(openChatId).listCollapsed;
    var filteredChats = chats.filter(function (chat) {
        if (["default", "unread"].includes(filter))
            return !chat.landlord_hide;
        else if (filter === "landlord_hide")
            return chat.landlord_hide;
        else if (filter === "tenant_blocked")
            return chat.tenant_blocked;
    });
    return (react_1.default.createElement("div", { id: "chat-list-panel", className: "minw-300 relative".concat(listCollapsed ? " chat-list-collapsed" : " border-end") },
        react_1.default.createElement(header_1.default, { filter: filter, setFilter: setFilter }),
        filter === "landlord_hide" && (react_1.default.createElement("div", { className: "text small gray border-start border-bottom px-2 py-3 italic tc" }, window.Translator.trans("chat.filter.hidden_hint", {}, "js"))),
        filteredChats.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("ul", { id: "chat-list", className: "flex-shrink-1" },
                filteredChats.map(function (chat, index) {
                    return (react_1.default.createElement(list_entry_1.default, { handleSwitchOpenChatId: handleSwitchOpenChatId, openChatId: openChatId, chat: chat, key: chat.id, isLast: index === chats.length - 1 }));
                }),
                react_1.default.createElement("li", null, hasNextPageChats &&
                    (!isFetchingNextPageChats ? (react_1.default.createElement("button", { className: "border-start p-2 small btn btn--primary w-100 rounded-0", onClick: fetchNextPageChats }, window.Translator.trans("chat.load_older_chats", {}, "js"))) : (react_1.default.createElement("span", { className: "border-start p-3 grid place-center" },
                        react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18" },
                            react_1.default.createElement("use", { href: "#loader" }))))))),
            react_1.default.createElement("div", { id: "chat-list-footer", className: "border-start flex-grow-1" }))) : (react_1.default.createElement("p", { className: "p-3 strong flex-grow-1 border-start tc" },
            "* ",
            window.Translator.trans("chat.no_chats_found", {}, "js"),
            " *"))));
}
exports.default = ChatListPanel;
